__turbopack_context__.v({
  "pagination": "cardList-module-scss-module__K3kuba__pagination",
  "wrapper": "cardList-module-scss-module__K3kuba__wrapper",
});
